import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { Question } from '../../../../types/course';

interface FillBlankEditorProps {
    question: Question;
    onChange: (updatedQuestion: Question) => void;
}

const FillBlankEditor: React.FC<FillBlankEditorProps> = ({ question, onChange }) => {
    return (
        <Box>
            <Typography variant="subtitle2" gutterBottom>Correct Answer (Case Insensitive):</Typography>
            <TextField
                fullWidth
                value={question.correctAnswer as string || ''}
                onChange={(e) => onChange({ ...question, correctAnswer: e.target.value })}
                placeholder="Enter the correct word or phrase..."
                helperText="The student's answer must match this text."
            />
        </Box>
    );
};

export default FillBlankEditor;
